import React, { useEffect } from "react";
import "./styles.css";
import { useLeadForm } from "../../../context/leadform";
import Select from "../../Inputs/Select";
import {
  CashSaleReason,
  PropertySaleReasonOptions,
  PropertyTimeframeOptions,
} from "../../../Leadform/options";
import { addDays } from "date-fns";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import RadioList from "../../Inputs/RadioList";

type TExcludeDate =
  | Array<{
      date: Date;
      message?: string;
    }>
  | Array<Date>;

const TimeframeStep = ({
  title,
  description,
}: {
  title: string;
  description: string;
}) => {
  const { updateValue } = useLeadForm();

  const includeDates: TExcludeDate = Array.from({ length: 300 }).map(
    (_, index) => addDays(new Date(), index + 7),
  );

  const onDateChange = (date: [Date | null, Date | null]) => {
    updateValue("timeframe", date[0]?.toLocaleDateString() || "");
  };

  return (
    <div className="Step TimeframeStep">
      <h2>{title}</h2>
      <p>{description}</p>

      <RadioList
        inline={false}
        perRow={3}
        options={PropertyTimeframeOptions}
        statekey="timeframe"
      />

      <div className="CustomDateInput">
        <label>Or choose a specific date below</label>
        <DatePicker
          includeDates={includeDates}
          selectsRange
          selectsDisabledDaysInRange
          inline
          onChange={onDateChange}
        />
      </div>
    </div>
  );
};

export default TimeframeStep;
